<template>
  <v-content class="mt-7 ml-7 mr-7">
    <v-container grid-list-md class="pb-0">
      <v-divider></v-divider>
      <div>
        <v-divider></v-divider>
        <template>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            onclick="window.location='https://intraug.ugto.mx/Perfiles'"
          >Agregar a la lista</v-btn>
        </template>
        <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="calories" class="elevation-1">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Usuarios</v-toolbar-title>
                    <v-spacer></v-spacer>
            <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
       
            
              <v-dialog v-model="dialog" max-width="800px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Agregar Roles</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex d-flex xs12 sm12 md12>
                          <v-text-field v-model="addUsRol.vnombre" readonly></v-text-field>
                          <v-text-field
                            v-model="addUsRol.NumeroEmpleado"
                            :items="addUsRol.vidempleado"
                            item-value="vidempleado"
                            :label="addUsRol.vidempleado"
                          ></v-text-field>
                          <!-- <v-text-field v-model="addUsRol.NumeroEmpleado"    ></v-text-field> -->
                        </v-flex>
                      </v-layout>
                    </v-container>

                    <!-- Inici DDL roles y Unidades -->
                    <v-container>
                      <v-flex xs12 sm9 d-flex>
                        <v-select
                          v-model="addUsRol.IdRol"
                          :items="respddlRol"
                          item-value="idRol"
                          item-text="nombre"
                          label="Rol"
                          outlined
                        ></v-select>
                      </v-flex>
                      <v-autocomplete
                        v-model=" unidadUsuario"
                        :items="respddlUnidades"
                        item-value="idUnidad"
                        item-text="nombreUnidad"
                        label="Unidades a las que pertenece"
                        multiple
                        chips
                      ></v-autocomplete>
                    </v-container>
                    <!-- <small>{{editedItem.idEmpleado}}</small> -->
                  </v-card-text>

                  <!-- Termina DDl Roles y Unidades  -->
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
            <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
            </v-icon>-->
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
      </div>
    </v-container>
  </v-content>
</template>
<script>
import axunidad from "axios";
import { async } from "q";

import { axiosSingleton } from "@/plugins/axios";
import  fraccionServices  from "../services/FraccionService";

//let apiUrl = 'https://colmenac.ugto.mx/rg/Transparencia/'
//let apiUrl = 'https://localhost:44340/'
let apiUrl = 'https://enjambrec.ugto.mx/RG/Transparencia/'

export default {
  data: () => ({
    unidadUsuario:[],
       search: '',
    Idrol: 0, //variable nombre que hacer referencia al valor del input
    NumeroEmpleado: "", //variable referencia al valor del input
    dialog: false,
    headers: [
      { text: "Nombre", value: "vnombre" },
      { text: "Perfil", value: "vdescripcion" },
      { text: "Permiso", value: "rnombre" },
      // { text: 'tipo fraccion', value: 'idTipoFraccion' },
      { text: "Acción", value: "action", sortable: false }
    ],

    desserts: [],
    objUsrsr: [],
    editedIndex: -1,
    addUsRol: {},
    defaultItem: {
      nombre: "",
      rol: 0,
      Unidad: 0,
      idEmpleado: 0,
      NumeroEmpleado: ""
    },
    respddlRol: [],
    respddlUnidades: [],
    items: [],
    arrayPersonas: [], //add persona
    unidadesUsuaio:[]
  }),

  computed: {},

  watch: {},

  created() {
    let self = this;
    self.initialize();
  },

  methods: {
    initialize() {
      let self = this;

      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.getCatUsuarios().then(r => {
        this.desserts = r.data.data;

         console.log( this.desserts);
      });
      self.ddlRoles(); //lanza la consulta ddl rol
      self.ddlUnidad(); //lanza la consulta ddl UNIDAD
    },

    async editItem(item) {
       let self = this;
      this.editedIndex = this.desserts.indexOf(item);
      this.addUsRol = Object.assign({}, item);
      console.log("editItem", this.addUsRol);
      self.unidaUsuario(item);
      this.dialog = true;
    },
       unidaUsuario(item) {
      let self = this;
 console.log("id tipo Usuario",item)
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.getUsUniadp(item.uidusuario).then(r => {
        this.unidadUsuario = r.data;

        console.log("unidad Usuario", this.unidadUsuario);
      });
    },


    deleteItem(item) {
      let self = this;
      var txt;
      const index = this.desserts.indexOf(item);
      console.log(item);
      var r = confirm("Borrar Usuario?") && this.desserts.splice(index, 1);
      // console.log(r);
      if (r.length == 1) {
        let self = this;
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.removeUser(item.uidusuario);
      } else {
        console.log("cancelar");
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.addUsRol = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      let selft = this;
      if (this.addUsRol.unempleado !== null) {
        //Editar usuario
        console.log("editar", this.addUsRol.unempleado);
        let self = this;
        this.addUsRol.unidad= this.unidadUsuario;
        Object.assign(this.desserts[this.editedIndex], this.addUsRol);
        //  debugger;
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
          .updateUserRol(self.addUsRol)
          .then(r => {
            self.initialize();
          })
          .catch(error => console.error("Error:", error))
          .then(response => console.log("Success:", response));
      } else {
        //Guardar usuario
        // var usadd = {IdRol:this.addUsRol.IdRol, NumeroEmpleado:this.addUsRol.vidempleado}
        console.log("Nuevo", this.addUsRol.unempleado);
           this.addUsRol.unidad= this.unidadUsuario;
        this.desserts.push(this.addUsRol);
        let self = this;
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
          .addUserRol(self.addUsRol)
          .then(r => {
            self.initialize();
          })
          .catch(error => console.error("Error:", error))
          .then(response => console.log("Success:", response));
      }
      this.close();
    },
    //ddl tipo de Rol

    ddlRoles() {
      let self = this;
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService.ddlRol().then(c => {
        this.respddlRol = c.data.data;
        //  this.respddlr= Object.assign({},this.respddlRol);
        console.log(this.respddlRol);
        // console.log(this.respddlRol.nombre);
      });
    },

    //ddl tipo de  Unidad

    ddlUnidad() {
      let self = this;

      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), apiUrl);
      fraccionService
        .getCatUnidad()
        .then(r => {
          this.respddlUnidades = r.data.data;
          console.log("ddl unudad", this.respddlUnidades);
        })
        .catch(error => console.error("Error:", error))
        .then(response => console.log("Success:", response));
    }
  }
};
</script>
